import Navbar from "../components/Navbar";
import parliamentsImage from "../assets/parliaments.png";

import '../css/home.css';
import Initiatives from "../components/Initiatives";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import Landing from "../components/Landing";
import Funds from "../components/Funds";
import BackToTop from "../components/BackToTop";

export default function Home() {
    return (
        <>
            <Navbar />

            <Landing />
            <section className="best-nation-section">
                <div className="best-nation-card">
                    <div className="best-nation-image">
                        <img src={parliamentsImage} alt="Best Nation Parliament" />
                    </div>
                    <div className="best-nation-content">
                        <p className="best-nation-tag">Best Nation Parliament</p>
                        <h2>Be a part of the nation-building movement</h2>
                        <p>
                            Join BNWO as a member and support welfare initiatives that bring dignity,
                            education, and hope to communities across Pakistan.
                        </p>
                        <a
                            className="best-nation-link"
                            href="https://docs.google.com/forms/d/e/1FAIpQLScTCOHr6lbZqFPfnY826H8ecU0mJ14d12FFlVG-Q6PuLCisjQ/viewform?usp=header"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Apply for Membership
                        </a>
                    </div>
                </div>
            </section>
            <Initiatives title="Meri Services" />
            <Funds />
            <ContactForm />
            <Footer />
            <BackToTop />
        </>
    );
}